import React, { useEffect, useState } from 'react';
import { API_URL } from './api';
import { stripeStatusLabel, trustedStripeUrl } from './StripeConnectSettings';

function ScopedStripeConnectOverview({ token }) {
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(''); setResult(null);
    fetch(`${API_URL}/api/master/payments/stripe`, { headers: { Authorization: `Bearer ${token}` } })
      .then(async (response) => {
        const payload = await response.json().catch(() => null);
        if (!response.ok || typeof payload?.configured !== 'boolean' || !Array.isArray(payload?.accounts)) {
          throw Error([401, 403].includes(response.status) ? 'Accès MASTER refusé.' : 'Suivi Stripe temporairement indisponible.');
        }
        if (active) setResult(payload);
      })
      .catch((failure) => {
        if (active) setError(failure.message === 'Accès MASTER refusé.' ? failure.message : 'Suivi Stripe temporairement indisponible.');
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [token, refresh]);

  return <section className="master-create-card stripe-connect" aria-labelledby="stripe-overview-title">
    <div className="master-section-title"><h2 id="stripe-overview-title">Stripe Connect — établissements</h2><p>Les restaurateurs encaissent sur leurs comptes. L’accès BERESTO s’exerce depuis le tableau de bord de la plateforme, dans les limites autorisées par Stripe.</p></div>
    {loading ? <p role="status">Vérification de la plateforme Stripe…</p> : null}
    {error ? <p role="alert" className="stripe-connect-error">{error}</p> : null}
    {result ? <>
      <p role="status"><strong>{result.configured ? 'Plateforme configurée' : 'Configuration de la plateforme en attente'}</strong>{result.mode === 'test' ? ' · Mode test, aucun encaissement réel' : result.mode === 'live' ? ' · Mode réel' : ''}</p>
      {!result.configured ? <p>Le compte Stripe de SASU BEQUANIM et la configuration Connect doivent être finalisés avant de proposer la connexion aux établissements.</p> : null}
      {result.accounts.length ? <div className="stripe-connect-table-wrap"><table className="stripe-connect-table"><thead><tr><th scope="col">Établissement</th><th scope="col">État du compte</th><th scope="col">Accès plateforme</th></tr></thead><tbody>
        {result.accounts.map((account) => {
          const dashboardUrl = account.connected ? trustedStripeUrl(account.dashboardUrl, 'dashboard') : '';
          return <tr key={account.id}><th scope="row">{account.name}</th><td>{stripeStatusLabel({ ...account, configured: result.configured, mode: result.mode })}</td><td>{dashboardUrl ? <a href={dashboardUrl} target="_blank" rel="noopener noreferrer" aria-label={`Voir ${account.name} dans Stripe`}>Voir dans Stripe</a> : account.connected ? 'Accès indisponible' : 'Non connecté'}</td></tr>;
        })}
      </tbody></table></div> : <p>Aucun compte connecté à afficher.</p>}
      <p className="stripe-connect-note">Cette vue présente le dernier statut enregistré. Le restaurateur peut actualiser son statut dans Administration → Exploitation → Paiements.</p>
    </> : null}
    <button type="button" className="master-secondary-button" disabled={loading} onClick={() => setRefresh((current) => current + 1)}>Actualiser Stripe</button>
  </section>;
}

export default function StripeConnectOverview({ token }) {
  return <ScopedStripeConnectOverview key={token} token={token} />;
}
